export default __webpack_public_path__ + "static/media/gallery-wip-neck-grenade_06.f48dcfdc.jpg";